import axios, { AxiosError } from 'axios';
import toast from 'react-hot-toast';
import { tokenStorage } from '@/utils/jwt';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  timeout: 30000,
});

api.interceptors.request.use((cfg) => {
  const t = tokenStorage.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError<{ ok?: boolean; code?: string; message?: string }>) => {
    const status = err.response?.status;
    const body = err.response?.data;
    // Sign-in answers 401 for a wrong password. Redirecting to /login here used to
    // reload the login page with no message; the page shows these errors inline.
    if (err.config?.url?.startsWith('/auth/')) return Promise.reject(err);
    if (status === 401) {
      tokenStorage.clear();
      window.location.replace('/login');
      return Promise.reject(err);
    }
    if (status === 403) { window.location.replace('/403'); return Promise.reject(err); }
    if (body?.message) toast.error(body.message);
    else if (err.message) toast.error(err.message);
    return Promise.reject(err);
  },
);
